import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./authCheck";
import { useEffect, useState } from "react";

const ProtectedRoute = ({ children }) => {
  const [auth, setAuth] = useState(null); // null = sjekker, true/false = resultat

  useEffect(() => {
    const checkAuth = async () => {
      const result = await isAuthenticated();
      setAuth(result);
    };

    checkAuth();
  }, []);

  if (auth === null) {
    return <div>Loading...</div>; // Vise en loader mens vi sjekker autorisasjon
  }

  return auth ? children : <Navigate to="/authentication/sign-in" />;
};

export default ProtectedRoute;
